// src/App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import LoginDemo from './LoginDemo';
import LoginCallback from './LoginCallback'
import LogoutCallback from './LogoutCallback'
import LoginOK from './LoginOK';

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/patient_list" element={<LoginOK />} />        
        <Route path="/login_callback" element={<LoginCallback />} />                
        <Route path="/logout_callback" element={<LogoutCallback />} />                
        <Route path="/" element={<LoginDemo />} />

      </Routes>
    </Router>
  );
};

export default App;
